import { FeatureFlagKey } from '@reward-platform/devcycle'
import { FeatureFlagMap } from '~/schemas/featureFlags'

export const evaluateFeatureFlagValue = <T extends string | number | boolean>(
  variableMap: FeatureFlagMap,
  key: FeatureFlagKey,
  defaultValue?: T
): T | null => {
  const variable = variableMap[key]
  return variable ? (variable.value as T) : defaultValue ?? null
}
